class LicenseInvoiceViewController extends MUIViewController
{
    static newInstance(): LicenseInvoiceViewController {
        let vc = new LicenseInvoiceViewController('licenses-detail-invoices-view');
        vc.initWithResource('layout/licenses/LicensesDetailInvoicesView.html');
        return vc;
    }

    private tableView:UITableView = null;
    private totalLabel:MUILabel = null;
    private distributorLabel:MUILabel = null;
    private profitLabel:MUILabel = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this as any;

        this.totalLabel = MUIOutlet( this, "footer-total-lbl", "MUILabel" );
        this.distributorLabel = MUIOutlet( this, "footer-distributor-lbl", "MUILabel" );
        this.profitLabel = MUIOutlet( this, "footer-profit-lbl", "MUILabel" );
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private businessLicense:BusinessLicense = null;
    set item(item:BusinessLicense) {
        this.businessLicense = item;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this.businessLicense == null) return;

        this.fetchedResultsController = null;
        this.updateTotals();
        this.tableView.reloadData();
    }

    numberOfSections(tableview:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as LicenseInvoice;

        let cell = tableview.dequeueReusableCellWithIdentifier("LicenseDetailInvoiceCell") as LicenseDetailInvoiceCell;
        cell.item = item;

        return cell;
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName("LicenseInvoice");
        fetchRequest.sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("date", false)];
        fetchRequest.predicate = MIOPredicate.predicateWithFormat("deletedAt = null and business.identifier == " + this.businessLicense.identifier);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.updateTotals();
        this.tableView.reloadData();
    }

    private updateTotals(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let total = 0;
        let distributor = 0;

        let objects = this.fetchedResultsController.fetchedObjects;
        for (let index = 0; index < objects.length; index++) {
            let inv = objects[index] as LicenseInvoice;
            total += inv.totalAmount || 0;
            distributor += inv.totalDistributorFeeAmount || 0;
        }

        this.totalLabel.text = ad.currencyFormatter.stringFromNumber( total );
        this.distributorLabel.text = ad.currencyFormatter.stringFromNumber( distributor );
        this.profitLabel.text = ad.currencyFormatter.stringFromNumber( total - distributor );
    }
}

class LicenseDetailInvoiceCell extends UITableViewCell
{
    private dateLabel:MUILabel = null;
    private documentLabel:MUILabel = null;
    private clientLabel:MUILabel = null;
    private distributorLabel:MUILabel = null;
    private totalLabel:MUILabel = null;

    awakeFromHTML(): void {
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.documentLabel = MUIOutlet(this, "document-lbl", "MUILabel");
        this.clientLabel = MUIOutlet(this, "cliente-lbl", "MUILabel");
        this.distributorLabel = MUIOutlet(this, "distributor-lbl", "MUILabel");
        this.totalLabel = MUIOutlet(this, "total-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private invoice:LicenseInvoice = null;
    set item(item:LicenseInvoice) {
        this.invoice = item;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        this.dateLabel.text = item.date != null ? ad.dateFormatter.stringFromDate( item.date ) : null;
        this.documentLabel.text = item.documentNumber;
        this.clientLabel.text = item.businessName;
        this.distributorLabel.text = item.distributorName;
        this.totalLabel.text = ad.currencyFormatter.stringFromNumber( item.totalAmount || 0 );
    }
}
